export function nextUniqueName(baseName, existingNames, separator = "_") {
  const base = String(baseName || "").trim() || "item";
  const used = new Set(
    Array.from(existingNames || [])
      .map((name) => String(name || "").trim())
      .filter(Boolean)
  );
  if (!used.has(base)) return base;

  let counter = 1;
  let candidate = `${base}${separator}${counter}`;
  while (used.has(candidate)) {
    counter += 1;
    candidate = `${base}${separator}${counter}`;
  }
  return candidate;
}

function escapeRegExp(value) {
  return String(value).replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}

export function duplicateSequenceName(
  sourceName,
  existingNames,
  separator = "_",
  fallback = "item"
) {
  const source = String(sourceName || "").trim() || fallback;
  const suffixPattern = new RegExp(`^(.*)${escapeRegExp(separator)}(\\d+)$`);
  const suffixMatch = source.match(suffixPattern);
  const base = (suffixMatch ? suffixMatch[1] : source).trim() || fallback;
  const used = new Set(
    Array.from(existingNames || [])
      .map((name) => String(name || "").trim())
      .filter(Boolean)
  );

  let counter = 1;
  let candidate = `${base}${separator}${counter}`;
  while (used.has(candidate)) {
    counter += 1;
    candidate = `${base}${separator}${counter}`;
  }
  return candidate;
}

export function namesFromRecord(record) {
  return Object.values(record || {})
    .map((entry) => entry?.name)
    .filter(Boolean);
}
